import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsMToP: readonly IndexedPublicationsSection[] = [
  {
    letter: 'M',
    references: [
      '@bib{macginnis1995letter};',
      '@bib{RN3094};',
      '@bib{Malko2017Dūr-Kurigalzu};',
      '@bib{RN715};',
      '@bib{MárquezRowe1997Inscripciones};',
      '@bib{MárquezRowe1998Dos};',
      '@bib{NABU2000-16};',
      '@bib{MárquezRowe2009Ceramic};',
      '@bib{MárquezRowe2011Un};',
      '@bib{MárquezRowe2012The};',
      '@bib{MárquezRowe2015Colección};',
      '@bib{marquezrowe2016middle};',
      '@bib{MárquezRowe2006Cuneiform};',
      '@bib{MárquezRowe1997The};',
      '@bib{Marti2005JMC5};',
      '@bib{Martin2023FSMaul};',
      '@bib{VS_25};',
      '@bib{VS_27}; ',
      '@bib{marzahn2000lobpreis};',
      '@bib{Marzahn2023FSMaul};',
      '@bib{RN1582aa};',
      '@bib{RN311j};',
      '@bib{RN366};',
      '@bib{RN364};',
      '@bib{RN2842}; ',
      '@bib{RN2223};',
      '@bib{RN977};',
      '@bib{RN901}; ',
      '@bib{Maul2012Paläographische};',
      '@bib{maul2013altorientalischer};',
      '@bib{KAL6};',
      '@bib{RN2805xs};',
      '@bib{KAL15}; ',
      '@bib{RN365};',
      '@bib{RN2844};',
      '@bib{RN355};',
      '@bib{mcewan1981priest};',
      '@bib{OECT_9};',
      '@bib{RN2108};',
      '@bib{mcewan1986seleucid};',
      '@bib{RN2740yy};',
      '@bib{UBHD-LS};',
      '@bib{OECT_4};',
      '@bib{meer1939tablets};',
      '@bib{LS272bb};',
      '@bib{RN347a};',
      '@bib{Meinhold2023FSMaul};',
      '@bib{RN2875};',
      '@bib{meissnerBabylonischenKleinplastiken1934};',
      '@bib{RN346};',
      '@bib{VS_1}; ',
      '@bib{Miglus2017Die};',
      '@bib{Miglus2023FSMaul};',
      '@bib{Millard1985Copy};',
      '@bib{Millard1985Royal};',
      '@bib{Millard1987Copy};',
      '@bib{Millard1988Text};',
      '@bib{Millard1990Fragments};',
      '@bib{Miller2017Political};',
      '@bib{HES_4};',
      '@bib{Mittermayer2023FSMaul};',
      '@bib{fromebllab0007};',
      '@bib{fromebllab0013};',
      '@bib{fromebllab0019};',
      '@bib{fromebllab0025}; ',
      '@bib{fromebllab0026};',
      '@bib{fromebllab0036};',
      '@bib{fromebllab0041};',
      '@bib{fromebllab0042};',
      '@bib{fromebllab0014};',
      '@bib{moldenke1893ctmma};',
      '@bib{Molina1989Una};',
      '@bib{Molina1990Un};',
      '@bib{Molina1991Tablillas};',
      '@bib{Molina1993Tablillas};',
      '@bib{Molina1996Tablillas};',
      '@bib{Molina1997Inscripciones};',
      '@bib{molina2000lexical};',
      '@bib{Molina1997Textos};',
      '@bib{PBS_3};',
      '@bib{moran1988amarna};',
      '@bib{Mouton2005JMC5};',
      '@bib{muḥammad2002texts};',
      '@bib{muḥammad1997دراسة};',
      '@bib{mueller-kessler2005zauberschalentexte}; ',
      '@bib{RN2800};',
      '@bib{BE_A_3_1}',
    ],
  },
  {
    letter: 'N',
    references: [
      '@bib{nemetnejat1982late};',
      '@bib{YOS_16};',
      '@bib{RN1438};',
      '@bib{NganTillard2018Two};',
      '@bib{niedroff2008mittelbabylonischen};',
      '@bib{Nougayrol 1967};',
      '@bib{Nougayrol1979}',
    ],
  },
  {
    letter: 'O',
    references: [
      '@bib{RN698};',
      '@bib{Oelsner1989MBLETU};',
      '@bib{Oelsner1990Eine};',
      '@bib{RN1458};',
      '@bib{Oelsner2023Nippur};',
      '@bib{Oller1987New};',
      '@bib{RN681};',
      '@bib{RN804};',
      '@bib{Ormsby1972Business};',
      '@bib{RN3639ax};',
      '@bib{RN7458};',
      '@bib{ossendrijver2017bm};',
      '@bib{ossendrijver2025babylonian};',
      '@bib{Nisaba_34}',
    ],
  },
  {
    letter: 'P',
    references: [
      '@bib{CT0053};',
      '@bib{RN311aa};',
      '@bib{RN311e};',
      '@bib{RN311}; ',
      '@bib{RN311g};',
      '@bib{RN311x};',
      '@bib{RN311aaa};',
      '@bib{Paulus2017Babylonian};',
      '@bib{PearceLate};',
      '@bib{RN1274};',
      '@bib{RN945}; ',
      '@bib{Pedersen2004fish};',
      '@bib{RN673};',
      '@bib{Pedersen2009Neo-Assyrian};',
      '@bib{Pedersén2025South};',
      '@bib{RN2589};',
      '@bib{Peterson2018Divine};',
      '@bib{CDLP-15.0};',
      '@bib{CDLP-16.0};',
      '@bib{CDLP-17.0};',
      '@bib{Peterson2020Sumerian};',
      '@bib{Peterson2020Poetic};',
      '@bib{Peterson2021Sumerian};',
      '@bib{fromebllab0033};',
      '@bib{Peterson2022Fragmentary};',
      '@bib{fromebllab0044};',
      '@bib{pettinato1970cuneiform};',
      '@bib{Pinches1888Peek};',
      '@bib{CT002};',
      '@bib{pinches1897some};',
      '@bib{CT004};',
      '@bib{CT006};',
      '@bib{Pinches1898Babylonian};',
      '@bib{CT008}; ',
      '@bib{pinches1900collection};',
      '@bib{pinches1902cylinder};',
      '@bib{RN1971a};',
      '@bib{pinches1911interesting};',
      '@bib{Pinches1915Berens};',
      '@bib{CT0044};',
      '@bib{CT0045};',
      '@bib{CT0055}; ',
      '@bib{CT0056};',
      '@bib{CT0057};',
      '@bib{RN808a};',
      '@bib{pingree1974neo-babylonian};',
      '@bib{pittman1988seal};',
      '@bib{BE_A_6_2};',
      '@bib{PBS_5}; ',
      '@bib{PBS_6_1};',
      '@bib{RN2145};',
      '@bib{LS244};',
      '@bib{LS244b}; ',
      '@bib{pohlVorsargonischeUndSargonische1935}; ',
      '@bib{pohlRechtsUndVerwaltungsurkunden1937};',
      '@bib{RN296}; ',
      '@bib{Porada1976Seal};',
      '@bib{postgate1969neoassyrian};',
      '@bib{UBHD-65157905};',
      '@bib{LS346};',
      '@bib{postgate1988middleassyrian};',
      '@bib{RN1507}; ',
      '@bib{postgate2000neoassyrian};',
      '@bib{MARV_10};',
      '@bib{RN2821};',
      '@bib{TMH_NF8};',
      '@bib{Proust2023Hermann}',
    ],
  },
]
